<template>
  <div id="app-timer">
    <secondHeader />
      <div class="main-timer">
        <sidebar />
        <div class="content-timer">
          <div class="timer-container">
          <!-- タイマー表示 + 操作 -->
          <div class="timer-hero">
            <h1 :style="timerStyle" :class="[timerFontAdjustClass, { 'timer-has-bg': showBg }]">
              <span v-if="timerSign" class="timer-sign">{{ timerSign }}</span>
              <span v-if="timerHours" class="timer-digits">{{ timerHours }}</span>
              <span v-if="timerHours" class="timer-colon">:</span>
              <span class="timer-digits">{{ timerMinutes }}</span>
              <span class="timer-colon">:</span>
              <span class="timer-digits">{{ timerSeconds }}</span>
            </h1>
            <div class="controls">
              <button v-on:click="startTimer" class="ctrl-btn ctrl-btn--start">▶ Start</button>
              <button v-on:click="stopTimer" class="ctrl-btn ctrl-btn--stop">■ Stop</button>
              <button v-on:click="resetTimer" class="ctrl-btn ctrl-btn--reset">Reset</button>
            </div>
          </div>

          <!-- 設定パネル：2カラム -->
          <div class="settings-grid">
            <!-- 左：タイマー設定 -->
            <div class="settings-card">
              <h3 class="card-title">タイマー設定</h3>

              <div class="field">
                <span class="field-label">モード</span>
                <div class="toggle-group">
                  <label class="toggle-option">
                    <input type="radio" value="up" v-model="mode" />
                    <span class="toggle-chip">カウントアップ</span>
                  </label>
                  <label class="toggle-option">
                    <input type="radio" value="down" v-model="mode" />
                    <span class="toggle-chip">カウントダウン</span>
                  </label>
                </div>
              </div>

              <div class="field">
                <span class="field-label">開始時間</span>
                <div class="time-inputs">
                  <label class="time-group">
                    <input type="number" v-model.number="inputHours" min="0" max="99" class="time-input" />
                    <span class="time-unit">時</span>
                  </label>
                  <label class="time-group">
                    <input type="number" v-model.number="inputMinutes" min="0" max="59" class="time-input" />
                    <span class="time-unit">分</span>
                  </label>
                  <label class="time-group">
                    <input type="number" v-model.number="inputSeconds" min="0" max="59" class="time-input" />
                    <span class="time-unit">秒</span>
                  </label>
                </div>
              </div>

              <div class="field">
                <button v-on:click="startFromMinusFive" class="shortcut-btn">-5秒からカウントアップ</button>
              </div>
            </div>

            <!-- 右：デザイン設定 -->
            <div class="settings-card">
              <h3 class="card-title">デザイン</h3>

              <div class="field">
                <span class="field-label">フォント</span>
                <div class="toggle-group toggle-group--font">
                  <label class="toggle-option">
                    <input type="radio" name="fontselect" value="Open Sans" v-model="font" />
                    <span class="toggle-chip toggle-chip--font font1">09:54</span>
                  </label>
                  <label class="toggle-option">
                    <input type="radio" name="fontselect" value="Iceland" v-model="font" />
                    <span class="toggle-chip toggle-chip--font font2">09:54</span>
                  </label>
                  <label class="toggle-option">
                    <input type="radio" name="fontselect" value="Josefin Sans" v-model="font" />
                    <span class="toggle-chip toggle-chip--font font3">09:54</span>
                  </label>
                  <label class="toggle-option">
                    <input type="radio" name="fontselect" value="Oxanium" v-model="font" />
                    <span class="toggle-chip toggle-chip--font font4">09:54</span>
                  </label>
                </div>
              </div>

              <div class="field">
                <span class="field-label">カラー</span>
                <div class="preset-list">
                  <button
                    v-for="(preset, idx) in colorPresets"
                    :key="idx"
                    class="preset-swatch"
                    :class="{ active: selectedPreset === idx }"
                    :style="{ backgroundColor: preset.bg, borderColor: preset.border, color: preset.text }"
                    @click="selectPreset(idx)"
                  >A</button>
                </div>
              </div>

              <div class="field">
                <label class="checkbox-row">
                  <input type="checkbox" v-model="showBg" class="checkbox-input" />
                  <span class="checkbox-text">背景を表示する</span>
                </label>
              </div>
            </div>
          </div>
          <div class="timer-howto">
            <h2>使い方</h2>
            <div class="timer-howto-text">
              <p class="timer-howto-text-title">このページはプレビューです。操作とデザイン変更はOBSに追加するコントローラーで行います。</p>
              <p>1. OBSの「ドック」→「カスタムブラウザドック」を開き、URLに「https://ruri.info/tool/simpletimercontrol」を入力して追加します。</p>
              <p>2. 表示されたコントローラーで、スタート/ストップやフォント・カラー・背景を設定できます。</p>
              <p>3. 下記のボタンでURLをコピーし、OBSのブラウザソースのURL欄に貼り付けます。</p>
              <button @click="copyLink" class="timer-howto-copy-button">リンクをコピー</button>
              <p>コントローラーの操作・設定はリアルタイムでブラウザソースに反映されます。</p>
            </div>
          </div>
          <div class="blog-area">
            <h2 class="blog-area-title">使い方はブログでチェック！</h2>
            <div class="blog-area-row">
              <div class="blog-area-thumb">
                <img class="article-list-img" src="@/assets/article/thombnail-timer.png">
              </div>
              <div class="blog-area-desc">
                <p>具体的な使い方や、おすすめのカスタマイズ方法はブログ記事で紹介しています。あわせてどうぞ！</p>
                <div class="blog-area-btn">
                  <a href="https://www.ruri.info/stopwatch/" target="_blank" rel="noopener noreferrer">
                    <span class="check-btn">記事をチェック</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="ad-block">
            <div class="ad">
              <InFeedAdsense
                  data-ad-layout-key="-fb+5w+4e-db+86"
                  data-ad-client="ca-pub-9016794589237931"
                  data-ad-slot="4898735474">
              </InFeedAdsense>
            </div>
          </div>
        </div>
        </div>
      </div>
  </div>
</template>

<script>
import secondHeader from "../components/secondHeader.vue"
import sidebar from "../components/sidebar.vue"
import timerMixin, { TIMER_KEYS, DEFAULT_FONT, fontAdjustClass } from '../mixins/simpleTimer'

export default {
  mixins: [timerMixin],
  components:{
      secondHeader,
      sidebar,
    },
  data() {
    return {
      timer: null,
      mode: 'up',
      inputHours: 0,
      inputMinutes: 0,
      inputSeconds: 0,
      font: DEFAULT_FONT,
      showBg: true,
      selectedPreset: 0,
    }
  },
  methods: {
    startTimer() {
      this.stopTimer();
      this.totalSeconds = this.inputHours * 3600 + this.inputMinutes * 60 + this.inputSeconds;
      this.timer = setInterval(this.tick, 1000);
    },
    stopTimer() {
      clearInterval(this.timer);
      this.timer = null;
    },
    resetTimer() {
      this.stopTimer();
      this.totalSeconds = 0;
    },
    startFromMinusFive() {
      this.stopTimer();
      this.totalSeconds = -5;
      this.mode = 'up';
      this.timer = setInterval(this.tick, 1000);
    },
    tick() {
      if (this.mode === 'up') {
        this.totalSeconds++;
      } else if (this.totalSeconds > 0) {
        this.totalSeconds--;
      } else {
        this.stopTimer();
      }
    },
    selectPreset(idx) {
      this.selectedPreset = idx;
    },
    copyLink() {
      navigator.clipboard.writeText(this.generatedLink).then(() => {
        alert('リンクがコピーされました');
      });
    }
  },
  computed: {
    generatedLink() {
      return `${window.location.origin}/tool/simpleTimerDesign`;
    },
    currentPreset() {
      return this.colorPresets[this.selectedPreset];
    },
    timerFontAdjustClass() {
      return fontAdjustClass(this.font);
    },
    timerStyle() {
      const style = {
        fontFamily: this.font,
        color: this.currentPreset.text
      };
      if (this.showBg) {
        style.backgroundColor = this.currentPreset.bg;
        style.borderColor = this.currentPreset.border;
      }
      return style;
    }
  },
  mounted() {
    // このページはローカルプレビュー専用。現在のデザイン設定を初期値として読み込むだけで、
    // 変更を localStorage には書き戻さない（本番のブラウザソースには影響しない）。
    this.showBg = localStorage.getItem(TIMER_KEYS.showBg) !== 'false';
    const savedPreset = localStorage.getItem(TIMER_KEYS.presetIndex);
    if (savedPreset !== null) {
      const idx = parseInt(savedPreset);
      if (idx >= 0 && idx < this.colorPresets.length) this.selectedPreset = idx;
    }
    const savedFont = localStorage.getItem(TIMER_KEYS.font);
    if (savedFont) this.font = savedFont;
  },
  beforeUnmount() {
    if (this.timer) clearInterval(this.timer);
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Iceland&family=Open+Sans:wght@500&family=Shadows+Into+Light&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Yuji+Mai&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Josefin+Sans:ital,wght@0,100..700;1,100..700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Oxanium:wght@200..800&display=swap');


.main-timer {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
}
.content-timer {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 60px 0 60px 1.82%;
  margin: 0 auto;
}

.ad-block{
  padding: 12px 0px;
  display: block;
  width: 100%;
}
.ad {
  max-height: 300px;
  max-width: 70%;
  margin: 0 auto;
  text-align: center;
  box-sizing: border-box;
  display: block;
}

#app-timer {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
}

.timer-container {
  max-width: 680px;
  text-align: center;
  margin: 0 auto;
  padding: 30px 20px;
}

.timer-container h1 {
  font-size: 5rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.18em 0.6em;
  margin: 0;
  line-height: 1.2;
  height: calc(5rem * 1.2);
}

/* フォントメトリクス上グリフが上に寄るため下方向に補正 */
.timer-container h1.font-josefin > span {
  transform: translateY(0.09em);
}

.timer-container h1.font-oxanium > span {
  transform: translateY(0.05em);
}

.timer-digits {
  display: inline-block;
  width: 2.1ch;
  text-align: center;
  vertical-align: bottom;
}

.timer-colon {
  display: inline-block;
  width: 0.7ch;
  text-align: center;
  opacity: 0.8;
  vertical-align: bottom;
}

.timer-sign {
  display: inline-block;
  width: 0.7ch;
  text-align: center;
  vertical-align: bottom;
}

.timer-has-bg {
  border-width: 0.12em;
  border-style: solid;
  border-radius: 0.12em;
}

/* Hero: Timer + Controls */
.timer-hero {
  margin-bottom: 36px;
}

.controls {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 20px;
}

.ctrl-btn {
  padding: 10px 24px;
  border-radius: 8px;
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}

.ctrl-btn:hover {
  opacity: 0.85;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.ctrl-btn:active {
  transform: translateY(0);
}

.ctrl-btn--start {
  background: #22c55e;
  color: #fff;
}

.ctrl-btn--stop {
  background: #ef4444;
  color: #fff;
}

.ctrl-btn--reset {
  background: #64748b;
  color: #fff;
}

/* Settings Grid */
.settings-grid {
  display: flex;
  gap: 20px;
  justify-content: center;
  text-align: left;
}

@media screen and (max-width: 600px) {
  .settings-grid {
    flex-direction: column;
    align-items: center;
  }
}

.settings-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  width: 280px;
}

.card-title {
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  margin: 0 0 16px 0;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f5f9;
}

/* Fields */
.field {
  margin-bottom: 16px;
}

.field:last-child {
  margin-bottom: 0;
}

.field-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 8px;
}

/* Toggle */
.toggle-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.toggle-option {
  position: relative;
  cursor: pointer;
}

.toggle-option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.toggle-chip {
  display: inline-block;
  padding: 7px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f8fafc;
  color: #64748b;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.15s ease;
}

.toggle-option input:checked + .toggle-chip {
  background: #0f172a;
  color: #ffffff;
  border-color: #0f172a;
}

.toggle-option:hover .toggle-chip {
  border-color: #94a3b8;
}

/* Time Inputs */
.time-inputs {
  display: flex;
  gap: 10px;
}

.time-group {
  display: flex;
  align-items: center;
  gap: 3px;
}

.time-input {
  width: 52px;
  padding: 7px 8px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  text-align: center;
  font-size: 15px;
  background: #f8fafc;
}

.time-input:focus {
  outline: none;
  border-color: #0f172a;
  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.1);
}

.time-unit {
  font-size: 12px;
  color: #64748b;
}

/* Shortcut */
.shortcut-btn {
  width: 100%;
  padding: 9px;
  border: 1px dashed #cbd5e1;
  border-radius: 6px;
  background: transparent;
  color: #475569;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}

.shortcut-btn:hover {
  background: #f1f5f9;
  border-color: #94a3b8;
}

/* Checkbox */
.checkbox-row {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.checkbox-input {
  width: 16px;
  height: 16px;
  accent-color: #0f172a;
}

.checkbox-text {
  font-size: 13px;
  color: #475569;
}

/* Font chips: 各フォントで文字幅が異なるためサイズを固定して揃える */
.toggle-group--font {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.toggle-group--font .toggle-option {
  width: 100%;
}

.toggle-chip--font {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  height: 38px;
  padding: 0 8px;
  font-size: 16px;
  font-variant-numeric: tabular-nums;
}

/* Fonts */
.font1 {
  font-family: "Open Sans", sans-serif;
}
.font2 {
  font-family: 'Iceland', cursive;
}
.font3 {
  font-family: 'Josefin Sans', sans-serif;
}
.font4 {
  font-family: 'Oxanium', sans-serif;
}

/* Preset */
.preset-list {
  display: flex;
  gap: 8px;
}

.preset-swatch {
  width: 34px;
  height: 34px;
  border-radius: 6px;
  border-width: 2.5px;
  border-style: solid;
  cursor: pointer;
  font-weight: bold;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.6;
  transition: all 0.15s ease;
}

.preset-swatch.active {
  opacity: 1;
  transform: scale(1.2);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.preset-swatch:hover {
  opacity: 1;
}


.content-block {
  padding: 20px; /* 必要な余白を指定 */
  max-width: 620px;
  margin: 0 auto;

  /* グラスフォーフィズム */
  background-color: rgba(255, 255, 255, 0.1); /* 背景色 */
  border: 1px solid rgba(255, 255, 255, 0.4); /* ボーダー */
  border-right-color: rgba(255, 255, 255, 0.2);
  border-bottom-color: rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  -webkit-backdrop-filter: blur(20px); /* ぼかしエフェクト */
  backdrop-filter: blur(20px);
  box-shadow: 4px 4px 8px rgb(0 0 0 / 2%);
}

.content-title {
  margin-bottom: 20px; /* 必要な余白を指定 */
  text-align: center;
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

.content-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px; /* 必要な余白を指定 */
}

.content-thumb {
    flex: 0 0 auto;
    margin-right: 20px; /* 必要な余白を指定 */
    width: 50%;
}

.content-thumb img{
    object-fit: contain;
    width: 100%;
}

.content-desc {
  width: 50%;
  word-wrap: break-word;
  font-size: 14px;
  letter-spacing: 2px;
}

.content-desc a{
  text-decoration:none;
}

.ariticle-btn{
  background: linear-gradient(-225deg, #acb6e5 0%, #C5C1FF 56%, #FFBAC3 100%);
  opacity: 0.75;
  border-radius: 10px;
  padding: 5px 12px ;
  color: white;
}

.ariticle-btn:hover{
  transform: translateY(-5px);
  box-shadow: 0 7px 34px rgba(50,50,93,.1), 0 3px 6px rgb(0 0 0 / 10%);
  transition: all .5s;
}

@media screen and (max-width: 600px) {
    .content-row {
        flex-direction: column;
    }

    .content-thumb, .content-desc {
        margin-right: 0;
        width: 100%;
    }
}
.blog-block{
  margin-top:2rem;
}

.blog-area{
  padding: 20px;
  max-width: 620px;
  margin: 3rem auto;
  border-bottom: 1px solid #212121;
  border-top: 1px solid #212121;
}

.blog-area-title{
  margin-bottom: 20px;
  text-align: center;
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

.blog-area-row{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  margin-top: 24px;
}

.blog-area-thumb{
  flex: 0 0 auto;
  margin-right: 20px;
  width: 50%;
}

.blog-area-thumb img{
    object-fit: contain;
    width: 100%;
}

.blog-area-desc{
  width: 50%;
  word-wrap: break-word;
  font-size: 14px;
  letter-spacing: 2px;
  text-align: left;
}

.blog-area-desc a{
  text-decoration:none;
}

.blog-area-btn{
  margin-top:2rem;
}

.check-btn{
  background-color: #212121;
  opacity: 0.75;
  border-radius: 8px;
  padding: 5px 12px ;
  color: white;
  transition: all .5s;
}

.check-btn:hover{
  box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.35);
	transform: translateY(-4px);
}


.timer-howto {
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.timer-howto h2 {
  margin-bottom: 10px;
}

.timer-howto-text {
  margin-bottom: 10px;
  text-align: left;
  width: 500px;
  line-height: 1.5;
}
.timer-howto-text-title {
  margin-bottom: 10px;
}
.timer-howto-copy-button {
  margin-bottom: 10px;
  padding: 10px 20px;
  background-color: #4c5c8a; /* 緑色の背景 */
  color: white; /* 白色の文字 */
  border: none; /* 枠線なし */
  border-radius: 5px; /* 角を丸くする */
  cursor: pointer; /* カーソルをポインターにする */
  transition: background-color 0.3s; /* 背景色の変化にアニメーションを追加 */
}

.timer-howto-copy-button:hover {
  background-color: #3b466a; /* ホバー時の背景色 */
}
</style>